import { Channel, eventChannel } from 'redux-saga';
import { call, fork, put, take } from 'redux-saga/effects';
import { setError } from './actions';
import { APOLLO_NORMALIZED_ERROR_EVENT, ApolloNormalizedErrorEvent } from '@shared/api/apollo';

const createGraphQLErrorChannel = () => {
	return eventChannel(emit => {
		const handler = (event: ApolloNormalizedErrorEvent) => {
			emit({ error: event.detail.error });
		};

		/* Предполагается, что есть глобальный обработчик ошибок GraphQL */
		document.addEventListener(APOLLO_NORMALIZED_ERROR_EVENT, handler);

		/* Функция, которая будет вызвана при отмене подписки */
		return () => {
			document.removeEventListener(APOLLO_NORMALIZED_ERROR_EVENT, handler);
		};
	});
};

function* handleGraphQLError() {
	const channel: Channel<ApolloNormalizedErrorEvent> = yield call(createGraphQLErrorChannel);

	try {
		while (true) {
			const { error } = yield take(channel);

			yield put(setError(error));
		}
	} finally {
		channel.close();
	}
}

export function* watchGraphQLError() {
	yield fork(handleGraphQLError);
}
